import { createAction, props } from '@ngrx/store';

export const initOnboardingAction = createAction('[Onboarding Page] Home page');

export const setOnboardingAction = createAction(
  '[Onboarding Page] set check',
  props<{ check: boolean }>()
);
